module.exports = __webpack_public_path__ + "media/images/new/roadpass_pro-89710633d125d7117587562565b6e93e.jpg";